module.exports = __webpack_public_path__ + "img/event-icon.ae39abbb.svg";